import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class BankService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('banks/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('banks/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('banks/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('banks/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('banks/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('banks/delete', val_id);
  }
}
